import { ErrorRouteComponent } from '@tanstack/react-router'

import { Typography } from '@forto-dev/phoenix-ui-core'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { createErrorFallback } from '@/fragments/create-error-fallback'
import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { Navigation } from '@/fragments/navigation'
import { useLocalisation } from '@/utils/localisation'

// Route-level error component: keeps the page chrome and shows the translated fallback, like OverviewErrorComponent.
export const DashboardErrorComponent: ErrorRouteComponent = ({ error, reset }) => {
  const { translate } = useLocalisation()

  return (
    <Layout
      header={<Header />}
      navigation={<Navigation />}
      title={<Typography variant="h4">{translate('navigation.dashboard')}</Typography>}
      main={createErrorFallback(translate('dashboard.errors.page'))({ error, reset })}
      footer={<Footer />}
    />
  )
}
